/**
 * Open/close state for the in-game help modal.
 *
 * Each game's page mounts a `<GameHelpModal>` with its own content
 * (title + sections of bullet items), and the menu items in the
 * setup-screen kebab and the in-game FAB call `open(source)` to show
 * it. Source values mirror the about-modal taxonomy (`setup_menu`,
 * `game_fab`) so help opens are attributable in analytics.
 */
export function useGameHelpModal() {
  const isOpen = useState('game-help-modal-open', () => false)
  const { trackEvent } = useAnalytics()

  return {
    close: () => { isOpen.value = false },
    isOpen,
    open: (source?: string) => {
      isOpen.value = true
      trackEvent('game_help_opened', source ? { source } : undefined)
    },
  }
}
